import { render } from "./Widget1.vue?vue&type=template&id=558dbede"
import script from "./Widget1.vue?vue&type=script&lang=ts"
export * from "./Widget1.vue?vue&type=script&lang=ts"
script.render = render

export default script